import React, { Fragment } from "react";
import {
    DEFAULT_ACTIVE_TAB_KEY,
    TABS,
    WEB_APP_URL,
} from "./RetailerSettingsConstants";
import { Tabs, Tab } from "react-bootstrap";
import SettingsGeneral from "./SettingsGeneral";
import SettingsGettingStarted from "./SettingsGettingStarted";
import SettingsBookingTools from "./SettingsBookingTools";
import SettingsLocations from "./SettingsLocations";
import SettingsSubscription from "./SettingsSubscription";
import SettingsQueues from "./SettingsQueues";
import UsersSchedules from "../Users/UsersSchedules";
import UsersQuestionnaires from "../Users/UsersQuestionnaires";
import UsersWebappSettings from "../Users/UsersWebappSettings";

const RetailerSettings = ({
    widgetToken,
    settings,
    isShopify,
    widgetSettings,
    token,
    zoomAppInstallUrl,
    pipedriveAppInstallUrl,
    zoomAccountEmail,
    setRefetch,
    user,
    flags,
}) => {
    const retailerWebappUrl = `${WEB_APP_URL}${widgetToken}`;

    const generalSettings = {
        name: settings.name,
        websiteUrl: settings.websiteUrl || "",
        email: settings.email || "",
        additionalEmails: settings.additionalEmails,
        address: settings.address,
        additionalAddresses: settings.additionalAddresses,
        isRetailerOnlineOnly: settings.isRetailerOnlineOnly,
        availableSubscriptions: settings.availableSubscriptions,
    };

    const locationsSettings = {
        virtualEmails: settings.virtualEmails,
        locationsEmails: settings.locationsEmails,
        fullLocations: settings.fullLocations,
        locationsPhoneNumbers: settings.locationsPhoneNumbers,
        virtualPhoneNumbers: settings.virtualPhoneNumbers,
        locationsSelectedCalendars: settings.locationsSelectedCalendars,
        calendars: settings.calendars,
        virtualCalendars: settings.virtualCalendars,
        mappedCalendars: settings.mappedCalendars,
        mappedVirtualCalendars: settings.mappedVirtualCalendars,
    };
    console.log("RetailerSettings", locationsSettings)

    const currentNumberOfBillableLocations = settings.fullLocations.filter(
        (location) => location.isBillable
    ).length;

    return (
        <>
            <Tabs defaultActiveKey={DEFAULT_ACTIVE_TAB_KEY}>
                <Tab
                    title={TABS.GENERAL.title}
                    eventKey={TABS.GENERAL.eventKey}
                >
                    <SettingsGeneral
                        isShopify={isShopify}
                        generalSettings={generalSettings}
                        setRefetch={setRefetch}
                        shouldHaveAllLocationsActive={
                            settings.shouldHaveAllLocationsActive
                        }
                        widgetImg={settings.retailerWidgetImage}
                    />
                </Tab>
                <Tab
                    title={TABS.GETTING_STARTED.title}
                    eventKey={TABS.GETTING_STARTED.eventKey}
                >
                    <SettingsGettingStarted
                        isShopify={isShopify}
                        widgetToken={widgetToken}
                        widgetSettings={widgetSettings}
                        widgetImg={settings.retailerWidgetImage}
                        widgetTextContent={settings.widgetTextContent}
                    />
                </Tab>
                <Tab
                    title={TABS.BOOKING_TOOLS.title}
                    eventKey={TABS.BOOKING_TOOLS.eventKey}
                >
                    <SettingsBookingTools
                        retailerWebappUrl={retailerWebappUrl}
                        token={token}
                        zoomAppInstallUrl={zoomAppInstallUrl}
                        pipedriveAppInstallUrl={pipedriveAppInstallUrl}
                        zoomAccountEmail={zoomAccountEmail}
                        retailerTimezone={settings.timezone}
                        retailerAppointmentInPersonOnly={
                            settings.appointmentInPersonOnly
                        }
                        retailerAppointmentVirtualOnly={
                            settings.appointmentVirtualOnly
                        }
                        isShopify={isShopify}
                        retailerCreateOderOnAppointmentCreation={
                            settings.createOrders
                        }
                        retailerCreateDraftOderOnAppointmentCreation={
                            settings.createDraftOrders
                        }
                        webappThemeColor={settings.webappThemeColor}
                        webappThemeTextColor={settings.webappThemeTextColor}
                        webappButtonColor={settings.webappButtonColor}
                        webappButtonTextColor={settings.webappButtonTextColor}
                    />
                </Tab>
                <Tab
                    title={TABS.LOCATIONS.title}
                    eventKey={TABS.LOCATIONS.eventKey}
                >
                    <SettingsLocations
                        locationsSettings={locationsSettings}
                        setRefetch={setRefetch}
                        user={user}
                        flags={flags}
                    />
                </Tab>
                {user.role === "admin" && (
                    <Tab
                        title={TABS.SUBSCRIPTION.title}
                        eventKey={TABS.SUBSCRIPTION.eventKey}
                    >
                        <SettingsSubscription
                            currentNumberOfBillableLocations={
                                currentNumberOfBillableLocations
                            }
                        />
                    </Tab>
                )}
                {!!flags?.queues_enabled && (
                    <Tab
                        title={TABS.QUEUES.title}
                        eventKey={TABS.QUEUES.eventKey}
                    >
                        <SettingsQueues />
                    </Tab>
                )}
                {!!flags?.employee_schedules_enabled &&
                    user.role === "manager" && (
                        <Tab
                            title={TABS.USERS_PROFILES.title}
                            eventKey={TABS.USERS_PROFILES.eventKey}
                        >
                            <Tabs>
                                <Tab
                                    title={
                                        TABS.USERS_PROFILES.tabs.USERS_SCHEDULE
                                            .title
                                    }
                                    eventKey={
                                        TABS.USERS_PROFILES.tabs.USERS_SCHEDULE
                                            .eventKey
                                    }
                                >
                                    <UsersSchedules
                                        retailerLocations={
                                            locationsSettings.fullLocations
                                        }
                                    />
                                </Tab>

                                <Tab
                                    title={
                                        TABS.USERS_PROFILES.tabs
                                            .USERS_QUESTIONNAIRE.title
                                    }
                                    eventKey={
                                        TABS.USERS_PROFILES.tabs
                                            .USERS_QUESTIONNAIRE.eventKey
                                    }
                                >
                                    <UsersQuestionnaires />
                                </Tab>

                                <Tab
                                    title={
                                        TABS.USERS_PROFILES.tabs
                                            .USERS_WEBAPP_SETTINGS.title
                                    }
                                    eventKey={
                                        TABS.USERS_PROFILES.tabs
                                            .USERS_WEBAPP_SETTINGS.eventKey
                                    }
                                >
                                    <UsersWebappSettings />
                                </Tab>
                            </Tabs>
                        </Tab>
                    )}
            </Tabs>
        </>
    );
};

export default RetailerSettings;
